import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, getCurrentInstance, ComponentInstance, computed } from 'vue';

// Helpers
import { formatWithLocale } from '@white-label-helper/date-utilities';
import { DATE_TIME_FORMATS } from '@white-label-helper/date-utilities';
import { useCountryOptions } from '@white-label-helper/shared-composables';

// Types
import { CartItem, Item as ReceiptOrderItem } from '@white-label-types/parking-checkout';

interface TravelInsuranceQuoteDetailsProps {
  product: CartItem | ReceiptOrderItem;
  component?: string;
}
export default /*#__PURE__*/_defineComponent({
  __name: 'travel-insurance-quote-details',
  props: {
    product: null,
    component: { default: '' }
  },
  setup(__props: any, { expose }) {

const props = __props as { product: CartItem | ReceiptOrderItem, component: string };

const { getCountryById } = useCountryOptions();
const { proxy } = getCurrentInstance() as ComponentInstance | null;

;



function formatTripDate(dateString: string) {
  if (dateString) {
    const date = new Date(dateString);
    return formatWithLocale(date, DATE_TIME_FORMATS.weekday_day_month_year, proxy?.$i18n.locale || 'en');
  }
  return '';
}

// Pulls quote details from cart or receipt data
const quoteDetails = computed(() => {
  const searchCriteria = 'search_criteria' in props.product
    ? props.product.search_criteria.travel_insurance
    : props.product.order_criteria?.travel_insurance
  if (!searchCriteria) return {};

  const destination = (searchCriteria.destination_countries ?? [])
    .map(dest => (typeof dest === 'string' ? dest : dest.code))
    .map(code => getCountryById(code).name)
    .join(', ');

  const travellerCount = (searchCriteria.additional_travellers?.length || 0) + 1;
  const travellersText = `${travellerCount} ${proxy.$tc('searchExtras.travelInsurance.productCard.nTravellers', travellerCount)}`;

  const subOptions = props.product?.inventory_option?.sub_options || [];
  const addOns = subOptions
    .filter(subOption => {
      if (subOption.id === 'base_package') return false;
      return subOption.selected === true || (subOption.totals?.quantity ?? 0) > 0;
    })
    .map(subOption => ({
      id: subOption.id,
      name: subOption.details?.name_formatted || subOption.details?.name
    }));

  return {
    destination,
    startDate: formatTripDate(searchCriteria.date1),
    endDate: formatTripDate(searchCriteria.date2),
    travellersText,
    addOns,
  };
});

expose({
  formatTripDate,
})

return { __sfc: true,getCountryById, proxy, props, formatTripDate, quoteDetails }
}

})